import { render, staticRenderFns } from "./WalletsSearch.vue?vue&type=template&id=64db140c&scoped=true&"
import script from "./WalletsSearch.vue?vue&type=script&lang=ts&"
export * from "./WalletsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./WalletsSearch.vue?vue&type=style&index=0&id=64db140c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db140c",
  null
  
)

export default component.exports